import * as React from "react";
import { pushSimpleEvent } from "@nju/data-layer";
import { Button, Separator, Text } from "@nju/ui";

export function InfoChat() {
  const openChat = React.useCallback(() => {
    if ("closer" in window) {
      // @ts-expect-error missing types
      closer.openWidget();
      pushSimpleEvent({
        event: "activity_chat",
        eventName: "chat_open",
      });
    }
  }, []);

  return (
    <div className="only-mobile:flex only-mobile:flex-col">
      <Text display="block" size="xl">
        chcesz zgłosić błąd lub potrzebujesz pomocy?
      </Text>
      <Separator tone="invisible" />
      <Text display="block">Napisz do konsultanta na czacie.</Text>
      <Separator size="s" tone="invisible" />
      <Button onPress={openChat}>włącz czat</Button>
    </div>
  );
}
